let API_URL = ""
let CLIENT_URL = ""

if (window.location.origin === 'http://localhost:3001') {
    API_URL = 'https://ci-mijia-world-api.imijiakeji.com'
} else {
    API_URL = window.location.origin
}

const APPID = 'wx15fcba0d5c748794'

export default {
  API_URL,
  CLIENT_URL,
  APPID
}



// WEBPACK FOOTER //
// ./src/global.js